import { render } from "./ProgramaCurva.vue?vue&type=template&id=7be45f35"
import script from "./ProgramaCurva.vue?vue&type=script&lang=js"
export * from "./ProgramaCurva.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__